<template>
  <section
    id="products"
    class="bg-gray-50 py-16 sm:py-24"
  >
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-3xl text-center">
        <span class="section-badge">Vlastný vývoj</span>
        <h2 class="section-title mt-4">Produkty</h2>
        <p class="section-subtitle">
          Keďže vývoj systémov nás v Himalii baví, okrem riešení na mieru máme aj
          vlastné produkty.
        </p>
      </div>

      <div class="mt-14 grid gap-8 lg:grid-cols-3">
        <article
          v-for="product in products"
          :key="product.name"
          class="card-surface flex flex-col overflow-hidden"
        >
          <div
            class="flex h-52 items-center justify-center bg-gradient-to-br from-gray-50 to-brand-50 p-8"
          >
            <img
              :src="product.image"
              :alt="product.name"
              class="max-h-full max-w-full object-contain"
            />
          </div>
          <div class="flex flex-1 flex-col p-6">
            <component
              :is="product.link ? 'a' : 'h3'"
              :href="product.link"
              :target="product.link ? '_blank' : undefined"
              :rel="product.link ? 'noopener noreferrer' : undefined"
              class="text-xl font-bold text-gray-900 transition"
              :class="
                product.link
                  ? 'text-brand-600 hover:text-brand-500'
                  : ''
              "
            >
              {{ product.name }}
              <span
                v-if="product.link"
                class="ml-1 inline-block text-brand-400"
                aria-hidden="true"
              >
                ↗
              </span>
            </component>
            <p class="mt-3 flex-1 text-sm leading-6 text-gray-600">
              {{ product.description }}
            </p>
            <div
              v-if="product.tags"
              class="mt-4 flex flex-wrap gap-2"
            >
              <span
                v-for="tag in product.tags"
                :key="tag"
                class="rounded-md bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-600"
              >
                {{ tag }}
              </span>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import setebosImg from "@/assets/setebos.png";
import homeflowImg from "@/assets/homeflow.png";
import remonoImg from "@/assets/remono.png";

export default {
  setup() {
    return {
      products: [
        {
          name: "Setebos",
          image: setebosImg,
          link: "https://setebos.sk",
          description:
            "Register právnických osôb, ktorý denne synchronizujeme. Bezplatná služba s API alebo automaticky dopĺňajúcim formulárom.",
          tags: ["API", "Open data", "Zadarmo"],
        },
        {
          name: "HomeFlow",
          image: homeflowImg,
          link: null,
          description:
            "Asistent pre inteligentné domácnosti. Dáta neopustia domácnosť majiteľa a vďaka end-to-end šifrovaniu ovládate dom z ľubovoľného miesta.",
          tags: ["IoT", "E2E šifrovanie", "Smart home"],
        },
        {
          name: "Remono",
          image: remonoImg,
          link: null,
          description:
            "Vzdialené ovládanie počítača — prenos obrazovky, klávesnica a myš cez zabezpečené rozhranie. Vzdialené zapnutie, reset a virtuálne úložisko.",
          tags: ["Remote", "Hardware", "Bezpečnosť"],
        },
      ],
    };
  },
};
</script>
